import Mutations from '../../odata/mutations';

export default { ...new Mutations('jobListingTask'), ...new Mutations('jobListingTasks') };
